/* StormX single-lure product template: gallery + lightbox, variant picker, qty, AJAX add to cart (Taiga drawer), sticky bar, size finder, tail action, hook picker, FAQ guard. */
(function () {
  'use strict';

  /* Taiga's global.js Accordion hijacks every <details> summary click and fails on our markup.
     Stop it in the capture phase so the browser toggles <details> natively (keyboard + screen reader friendly). */
  document.addEventListener('click', function (e) {
    var s = e.target && e.target.closest && e.target.closest('.sxp .sp-faq summary');
    if (s) e.stopPropagation();
  }, true);

  function money(cents, cur) {
    try { return new Intl.NumberFormat('en-NZ', { style: 'currency', currency: cur || 'NZD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function init(root) {
    if (root.__sp) return; root.__sp = true;
    var cur = root.getAttribute('data-currency') || 'NZD';

    /* ---------- gallery ---------- */
    var track = root.querySelector('[data-sp-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.sp-slide')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sp-thumb]'));
    var idx = 0;
    function go(i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      setActive(i);
    }
    var dots = Array.prototype.slice.call(root.querySelectorAll('.sp-dot'));
    function setActive(i) {
      idx = i;
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    }
    if (track) {
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-sp-thumb')); }); });
      var prev = root.querySelector('[data-sp-prev]'), next = root.querySelector('[data-sp-next]');
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      });
      var t0;
      track.addEventListener('scroll', function () {
        clearTimeout(t0);
        t0 = setTimeout(function () { var w = track.clientWidth || 1; setActive(Math.round(track.scrollLeft / w)); }, 60);
      }, { passive: true });
    }
    function goMedia(id) {
      if (!id) return;
      for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-media-id') == id) { go(i); return; }
    }

    initV2(root, { go: go, index: function () { return idx; } });

    /* ---------- variants ---------- */
    var form = root.querySelector('[data-sp-form]');
    if (!form) return;
    var idInput = form.querySelector('[data-sp-id]');
    var atc = form.querySelector('[data-sp-atc]');
    var atcLabel = form.querySelector('[data-sp-atc-label]');
    var atcText = atcLabel ? atcLabel.textContent : 'Add to cart';
    var msg = form.querySelector('[data-sp-msg]');
    var qtyInput = form.querySelector('[data-sp-qty-input]');
    var sticky = root.querySelector('[data-sp-sticky]');
    var stickyBtn = root.querySelector('[data-sp-sticky-btn]');
    var stickyText = stickyBtn ? stickyBtn.textContent : 'Add to cart';
    var variants = [];
    try { variants = JSON.parse((root.querySelector('[data-sp-variants]') || {}).textContent || '[]'); } catch (e) {}

    function current() {
      var id = +idInput.value;
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return variants[0];
    }
    function paint(v) {
      if (!v) return;
      idInput.value = v.id;
      var now = root.querySelector('[data-sp-now]'), was = root.querySelector('[data-sp-was]');
      if (now) now.textContent = v.price_fmt;
      if (was) { was.textContent = v.compare_fmt; was.hidden = !(v.compare > v.price); }
      var per = root.querySelector('[data-sp-per]');
      if (per) {
        per.hidden = !(v.pack > 0);
        var pk = per.querySelector('[data-sp-pack]'), pp = per.querySelector('[data-sp-per-price]');
        if (pk) pk.textContent = v.pack; if (pp) pp.textContent = v.per_fmt;
      }
      var sp = root.querySelector('[data-sp-sticky-price]'); if (sp) sp.textContent = v.price_short;
      atc.disabled = !v.available; atc.setAttribute('aria-disabled', String(!v.available));
      if (atcLabel) atcLabel.textContent = v.available ? atcText : 'Sold out';
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? stickyText : 'Sold out'; }
      goMedia(v.media);
    }
    var fieldsets = Array.prototype.slice.call(form.querySelectorAll('[data-sp-option]'));
    function markAvailability() {
      /* cross out values that have no available variant combined with the other current selections */
      var sel = current() ? current().options.slice() : [];
      fieldsets.forEach(function (fs) {
        var oi = +fs.getAttribute('data-sp-option');
        fs.querySelectorAll('input[type=radio]').forEach(function (r) {
          var want = sel.slice(); want[oi] = r.value;
          var ok = variants.some(function (v) { return v.available && v.options.every(function (o, n) { return o === want[n]; }); });
          r.closest('.sp-var-btn').classList.toggle('is-na', !ok);
        });
      });
    }
    if (fieldsets.length) {
      form.addEventListener('change', function (e) {
        if (!e.target.matches('input[type=radio]')) return;
        var sel = current().options.slice();
        fieldsets.forEach(function (fs) {
          var c = fs.querySelector('input:checked'); if (!c) return;
          sel[+fs.getAttribute('data-sp-option')] = c.value;
          var lab = fs.querySelector('[data-sp-optval]'); if (lab) lab.textContent = c.value;
        });
        var match = variants.filter(function (v) { return v.options.every(function (o, n) { return o === sel[n]; }); })[0];
        if (match) {
          paint(match);
          try { var u = new URL(location.href); u.searchParams.set('variant', match.id); history.replaceState(null, '', u.toString()); } catch (err) {}
        } else {
          atc.disabled = true; if (atcLabel) atcLabel.textContent = 'Unavailable';
        }
        markAvailability();
      });
      markAvailability();
    }

    /* ---------- qty ---------- */
    form.querySelectorAll('[data-sp-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-sp-qty'), 10);
        qtyInput.value = Math.max(1, Math.min(99, n));
      });
    });
    qtyInput.addEventListener('change', function () { var n = parseInt(qtyInput.value, 10); qtyInput.value = isNaN(n) ? 1 : Math.max(1, Math.min(99, n)); });

    /* ---------- free shipping progress ---------- */
    var shipEl = root.querySelector('[data-sp-ship-progress]');
    var threshold = parseInt(root.getAttribute('data-free-threshold'), 10) || 0;
    function shipLine(total) {
      if (!shipEl) return;
      if (cur !== 'NZD' || !threshold) { shipEl.textContent = ''; return; }
      if (!total) { shipEl.textContent = ''; return; }
      shipEl.textContent = total >= threshold ? 'Your cart qualifies (NZ orders).' : 'You’re ' + money(threshold - total, cur) + ' away.';
    }
    shipLine(parseInt(root.getAttribute('data-cart-total'), 10) || 0);

    /* ---------- fly a pack thumbnail from the button to the header cart icon (skipped with reduced motion) ---------- */
    var lastFrom = null;
    function fly(from) {
      lastFrom = null;
      var reduceM = matchMedia('(prefers-reduced-motion: reduce)').matches;
      var cartIco = Array.prototype.slice.call(document.querySelectorAll('a[href="#drawer-cart"], header a[href$="/cart"], .header a[href$="/cart"], a[href$="/cart"][data-drawer-toggle], a.header__icon--cart, #cart-icon-bubble, a[href="/cart"]'))
        .filter(function (el) { var r = el.getBoundingClientRect(); return r.width && r.height && !el.closest('.sxp'); })[0];
      var src = root.querySelector('.sp-slide img');
      if (reduceM || !cartIco || !src || !from || !Element.prototype.animate) return Promise.resolve();
      var a = from.getBoundingClientRect(), b = cartIco.getBoundingClientRect();
      var el = document.createElement('div'); el.className = 'sp-fly'; el.setAttribute('aria-hidden', 'true');
      var im = document.createElement('img'); im.src = src.currentSrc || src.src; im.alt = ''; el.appendChild(im);
      var x0 = a.left + a.width / 2 - 32, y0 = a.top + a.height / 2 - 32, x1 = b.left + b.width / 2 - 32, y1 = b.top + b.height / 2 - 32;
      el.style.left = x0 + 'px'; el.style.top = y0 + 'px';
      document.body.appendChild(el);
      var dx = x1 - x0, dy = y1 - y0;
      var anim = el.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * .45 + 'px,' + (dy * .45 - 90) + 'px) scale(.8) rotate(-12deg)', opacity: 1, offset: .5 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.25) rotate(0)', opacity: .6 }
      ], { duration: 720, easing: 'cubic-bezier(.5,0,.3,1)' });
      return new Promise(function (res) {
        var done = function () { el.remove(); cartIco.classList.remove('sp-cart-bump'); void cartIco.offsetWidth; cartIco.classList.add('sp-cart-bump'); res(); };
        anim.onfinish = done; setTimeout(function () { if (el.isConnected) done(); }, 1100);
      });
    }

    /* ---------- add to cart (native /cart/add.js, then Taiga's drawer) ---------- */
    var busy = false;
    function say(text, ok) { if (!msg) return; msg.textContent = text; msg.className = 'sp-msg ' + (ok ? 'is-ok' : 'is-err'); }
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; /* no-JS style fallback: normal POST to /cart/add */
      e.preventDefault();
      if (busy || atc.disabled) return;
      busy = true; atc.classList.add('is-loading'); atc.setAttribute('aria-busy', 'true'); say('', true);
      if (atcLabel) atcLabel.textContent = 'Adding…';
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: +idInput.value, quantity: qty }] })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; });
      }).then(function () {
        var drawerCart = document.querySelector('[data-drawer] cart-items');
        if (drawerCart) {
          atc.classList.remove('is-loading'); atc.classList.add('is-added'); if (atcLabel) atcLabel.textContent = 'Added';
          setTimeout(function () { atc.classList.remove('is-added'); if (atcLabel && !atc.disabled) atcLabel.textContent = atcText; }, 2200);
          say('Added to cart.', true);
          return fly(lastFrom || atc).then(function () {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added')); /* Taiga: refreshes + opens the cart drawer, updates the header count */
            return fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } });
          }).then(function (r) { return r.json(); }).then(function (c) { shipLine(c.total_price); root.dispatchEvent(new CustomEvent('sp:added', { bubbles: true, detail: c })); });
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
      }).catch(function (err) {
        say(err.message || 'Could not add to cart. Please try again.', false);
        if (atcLabel) atcLabel.textContent = atcText;
      }).then(function () {
        busy = false; atc.classList.remove('is-loading'); atc.removeAttribute('aria-busy');
      });
    });

    /* ---------- Fast Bundle mix-and-match widget (#rbr-container-element…) mounts right after the product form.
       Move it below the colour/size pickers so the buy flow stays: price → add to cart → options → offers. ---------- */
    var fbSlot = root.querySelector('[data-sp-fb-slot]');
    if (fbSlot && 'MutationObserver' in window) {
      var moveFb = function () {
        var w = root.querySelector('.sp-buy > [id^="rbr-container-element"]');
        if (w && w.parentNode !== fbSlot) fbSlot.appendChild(w);
      };
      moveFb();
      var mo = new MutationObserver(moveFb);
      mo.observe(root.querySelector('.sp-buy'), { childList: true });
      setTimeout(function () { mo.disconnect(); }, 20000);
    }

    /* ---------- mobile sticky bar ---------- */
    if (sticky && stickyBtn && typeof window.IntersectionObserver === 'function') {
      var pastBuy = false, nearEnd = false;
      function upd() {
        var on = pastBuy && !nearEnd;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', String(!on));
        stickyBtn.tabIndex = on ? 0 : -1;
      }
      new IntersectionObserver(function (en) {
        en.forEach(function (x) { pastBuy = !x.isIntersecting && x.boundingClientRect.top < 0; });
        upd();
      }).observe(atc);
      var foot = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer.site-footer, #shopify-section-footer');
      if (foot) new IntersectionObserver(function (en) { en.forEach(function (x) { nearEnd = x.isIntersecting; }); upd(); }).observe(foot);
      stickyBtn.addEventListener('click', function () {
        lastFrom = stickyBtn;
        if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
      });
    }
  }

  /* ---------- v2: lightbox, size finder, tail action, hook picker, review highlights ---------- */
  function initV2(root, api) {
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* lightbox (native <dialog>: focus trap, Esc, inert page). Full-size image is only requested on open. */
    var lb = root.querySelector('[data-sp-lb]');
    var zslides = Array.prototype.slice.call(root.querySelectorAll('[data-sp-zoom-src]'));
    if (lb && zslides.length && typeof lb.showModal === 'function') {
      var img = lb.querySelector('[data-sp-lb-img]'), stage = lb.querySelector('[data-sp-lb-stage]'), cnt = lb.querySelector('[data-sp-lb-count]');
      var li = 0, opener = null;
      var show = function (i) {
        li = (i + zslides.length) % zslides.length;
        stage.classList.remove('is-zoom'); img.style.transformOrigin = '';
        img.src = zslides[li].getAttribute('data-sp-zoom-src'); img.alt = zslides[li].getAttribute('data-sp-zoom-alt') || '';
        cnt.textContent = 'Image ' + (li + 1) + ' of ' + zslides.length;
      };
      var open = function (i, from) { opener = from || document.activeElement; show(i); lb.showModal(); lb.querySelector('[data-sp-lb-close]').focus(); };
      zslides.forEach(function (f, i) { f.addEventListener('click', function () { open(i, root.querySelector('[data-sp-zoom]')); }); });
      var zb = root.querySelector('[data-sp-zoom]');
      if (zb) zb.addEventListener('click', function () { open(api.index(), zb); });
      lb.querySelector('[data-sp-lb-close]').addEventListener('click', function () { lb.close(); });
      var lp = lb.querySelector('[data-sp-lb-prev]'), ln = lb.querySelector('[data-sp-lb-next]');
      if (zslides.length < 2) { lp.hidden = true; ln.hidden = true; }
      lp.addEventListener('click', function () { show(li - 1); });
      ln.addEventListener('click', function () { show(li + 1); });
      lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') show(li + 1); if (e.key === 'ArrowLeft') show(li - 1); });
      lb.addEventListener('close', function () { img.removeAttribute('src'); api.go(li); if (opener && opener.focus) opener.focus(); });
      stage.addEventListener('click', function (e) {
        if (e.target !== img) { lb.close(); return; }
        var r = img.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        stage.classList.toggle('is-zoom');
      });
      var sx = null;
      stage.addEventListener('touchstart', function (e) { sx = e.touches.length === 1 && !stage.classList.contains('is-zoom') ? e.touches[0].clientX : null; }, { passive: true });
      stage.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) show(li + (dx < 0 ? 1 : -1)); sx = null; }, { passive: true });
    }

    /* find your size: species buttons filter the model/size cards */
    var find = root.querySelector('[data-sp-find]');
    if (find) {
      var picks = Array.prototype.slice.call(find.querySelectorAll('[data-sp-pick]'));
      var cards = Array.prototype.slice.call(find.querySelectorAll('[data-sp-species]'));
      var status = find.querySelector('[data-sp-find-status]');
      var initial = status ? status.textContent : '';
      picks.forEach(function (b) {
        b.addEventListener('click', function () {
          var on = b.getAttribute('aria-pressed') !== 'true';
          picks.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          var key = on ? b.getAttribute('data-sp-pick') : '';
          if (on) b.setAttribute('aria-pressed', 'true');
          var names = [];
          cards.forEach(function (c) {
            var hit = !key || c.getAttribute('data-sp-species').indexOf('|' + key + '|') > -1;
            c.classList.toggle('is-out', !hit);
            c.classList.toggle('is-match', !!key && hit);
            c.querySelectorAll('[data-sp-sk]').forEach(function (s) { s.classList.toggle('is-hit', !!key && s.getAttribute('data-sp-sk') === key); });
            if (key && hit) names.push(c.querySelector('.sp-fcard-t').textContent.trim());
          });
          if (!status) return;
          if (!key) status.textContent = initial;
          else if (!names.length) status.textContent = 'No StormX size is listed for ' + b.textContent.trim() + ' yet.';
          else status.textContent = b.textContent.trim() + ': ' + names.length + ' match' + (names.length > 1 ? 'es' : '') + ' (' + names.join(', ') + ').';
        });
      });
    }

    /* tail action: plays while on screen (not with reduced motion unless the visitor presses play) */
    var tail = root.querySelector('[data-sp-tail]');
    if (tail) {
      var tb = tail.querySelector('[data-sp-tail-toggle]'), tl = tail.querySelector('[data-sp-tail-label]');
      var want = false, visible = false;
      var sync = function () {
        var play = want && visible;
        tail.classList.toggle('is-play', play);
        tb.setAttribute('aria-pressed', String(want));
        tl.textContent = want ? 'Pause animation' : 'Play animation';
      };
      tb.addEventListener('click', function () { want = !want; sync(); });
      var box = tail.querySelector('.sp-tail-box');
      tail.querySelectorAll('[data-sp-tail-pick]').forEach(function (b) {
        b.addEventListener('click', function () {
          var t = b.getAttribute('data-sp-tail-pick');
          if (box) box.setAttribute('data-show', t);
          tail.querySelectorAll('[data-sp-tail-pick]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        });
      });
      if (typeof window.IntersectionObserver === 'function') new IntersectionObserver(function (en) { en.forEach(function (x) { visible = x.isIntersecting; }); sync(); }, { rootMargin: '0px 0px -10% 0px' }).observe(tail);
      else { visible = true; }
      sync();
    }

    /* scroll reveal: subtle fade/slide as blocks enter the viewport (opacity/transform only, so no layout shift).
       Robust by design: content is visible without JS (the hidden state only exists once .sp-rv is added here);
       IO fires early (threshold 0, 15% below-the-fold margin); a throttled scroll check backs up IO;
       everything is revealed if IO is missing, never reports, or the page is printed. */
    (function () {
      var sel = '.sp-proof-list li,.sp-fit-intro,.sp-find,.sp-tail-head,.sp-tail-box,.sp-size-block h2,.sp-rig-visual,.sp-steps li,.sp-ship-list li,.sp-reviews h2,.sp-rev-hl,.sp-rev,.sp-cross h2,.sp-card,.sp-faq-grid>div';
      if (reduce || !(typeof window.IntersectionObserver === 'function')) return; /* nothing is ever hidden */
      var vh = window.innerHeight;
      var rv = Array.prototype.slice.call(root.querySelectorAll(sel)).filter(function (el) { return el.getBoundingClientRect().top > vh; });
      if (!rv.length) return;
      rv.forEach(function (el) {
        var i = el.parentNode ? Array.prototype.indexOf.call(el.parentNode.children, el) : 0;
        el.style.setProperty('--d', Math.min(i, 4) * 0.06 + 's');
        el.classList.add('sp-rv');
      });
      root.classList.add('sp-rv-on');
      var left = rv.length, fired = false;
      var show = function (el) { if (!el.classList.contains('is-in')) { el.classList.add('is-in'); left--; } };
      var showAll = function () { rv.forEach(show); cleanup(); };
      var io = new IntersectionObserver(function (en) {
        fired = true;
        en.forEach(function (x) { if (x.isIntersecting) { show(x.target); io.unobserve(x.target); } });
        if (left <= 0) cleanup();
      }, { threshold: 0, rootMargin: '0px 0px 15% 0px' });
      rv.forEach(function (el) { io.observe(el); });
      var tk = false;
      var onScroll = function () {
        if (tk) return; tk = true;
        requestAnimationFrame(function () {
          tk = false; var lim = window.innerHeight * 1.15;
          rv.forEach(function (el) { if (!el.classList.contains('is-in') && el.getBoundingClientRect().top < lim) show(el); });
          if (left <= 0) cleanup();
        });
      };
      var cleanup = function () { io.disconnect(); window.removeEventListener('scroll', onScroll); window.removeEventListener('beforeprint', showAll); };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('beforeprint', showAll);
      var failsafe = function () { setTimeout(function () { if (!fired) showAll(); else onScroll(); }, 2500); };
      if (document.readyState === 'complete') failsafe(); else window.addEventListener('load', failsafe);
    })();

    /* plastic-free strip: animated icons + count-up of the real stat */
    var proof = root.querySelector('.sp-proof');
    if (proof && typeof window.IntersectionObserver === 'function') {
      var pcnt = proof.querySelector('[data-sp-count]');
      var target = pcnt ? +pcnt.getAttribute('data-sp-count') : 0;
      var fmt = function (n) { return Math.round(n).toLocaleString('en-NZ'); };
      if (pcnt && !reduce && proof.getBoundingClientRect().top > window.innerHeight) pcnt.textContent = '0';
      var pio = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (!x.isIntersecting) return;
          pio.disconnect(); proof.classList.add('is-in');
          if (!pcnt || reduce) { if (pcnt) pcnt.textContent = fmt(target); return; }
          var t0 = null, dur = 1600;
          var step = function (ts) { if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / dur); pcnt.textContent = fmt(target * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); };
          requestAnimationFrame(step);
        });
      }, { threshold: .35 });
      pio.observe(proof);
    }

    /* colour swatches: crossfade the sibling's main photo over the gallery, then navigate on tap */
    var prevImg = root.querySelector('[data-sp-gal-preview]'), colName = root.querySelector('[data-sp-colname]');
    if (prevImg) {
      var col0 = colName ? colName.textContent : '';
      var hideT;
      var showP = function (a) {
        var u = a.getAttribute('data-sp-preview'); if (!u || a.classList.contains('is-current')) return;
        clearTimeout(hideT); prevImg.hidden = false;
        if (prevImg.getAttribute('src') !== u) prevImg.src = u;
        requestAnimationFrame(function () { prevImg.classList.add('is-on'); });
        if (colName) colName.textContent = a.getAttribute('data-sp-name');
      };
      var hideP = function () { prevImg.classList.remove('is-on'); if (colName) colName.textContent = col0; hideT = setTimeout(function () { prevImg.hidden = true; }, 400); };
      root.querySelectorAll('.sp-sw[data-sp-preview]').forEach(function (a) {
        a.addEventListener('mouseenter', function () { showP(a); });
        a.addEventListener('mouseleave', hideP);
        a.addEventListener('focus', function () { showP(a); });
        a.addEventListener('blur', hideP);
        a.addEventListener('click', function (e) {
          if (a.classList.contains('is-current') || reduce || e.metaKey || e.ctrlKey || e.shiftKey) return;
          e.preventDefault(); showP(a); a.classList.add('is-going');
          setTimeout(function () { location.href = a.href; }, 420);
        });
      });
    }

    /* rigging: Jig head / Weedless tabs (WAI-ARIA tabs: click, Left/Right/Home/End) */
    var rt = root.querySelector('[data-sp-rigtabs]');
    if (rt) {
      var tabs = Array.prototype.slice.call(rt.querySelectorAll('[data-sp-rigtab]'));
      var select = function (t, focus) {
        tabs.forEach(function (x) {
          var on = x === t;
          x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1;
          var panel = root.querySelector('#' + CSS.escape(x.getAttribute('aria-controls')));
          if (!panel) return;
          panel.hidden = !on;
          if (on && !reduce) { panel.classList.remove('is-enter'); void panel.offsetWidth; panel.classList.add('is-enter'); }
          if (on) panel.querySelectorAll('.sp-rv').forEach(function (el) { el.classList.add('is-in'); });
        });
        if (focus) t.focus();
      };
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t, false); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') n = tabs[0];
          else if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    }

    /* review highlight chips: jump to the review and flash it */
    root.querySelectorAll('[data-sp-rev-jump]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = root.querySelector(a.getAttribute('href'));
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        t.focus({ preventScroll: true });
        t.classList.add('is-flash'); setTimeout(function () { t.classList.remove('is-flash'); }, 1600);
      });
    });
  }

  function boot() { document.querySelectorAll('[data-sxp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
